export default __webpack_public_path__ + "static/media/Reddit5.01f861c6.PNG";